module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAAAXNSR0IArs4c6QAAAIhJREFUWAnt18EKgCAURFGf///PalvRhbwrIVx3SU5yGiKjQKONsYqKMVbzp3P1dMFf97tRWl5RRWkBOs+OKkoL0Hl2VFFagM6zo7Ro7P7M6Qdl83z1WcF5vaKzSPb6GVHkzP1p7b4enuuzXbq1/pmOulG6AooqSgvQeXZUUVqAzrOjitICdF4Hy38MTtq0cwUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/icon-plus.png
// module id = 325
// module chunks = 0